import React, { useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { supabase } from "../../client";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";

const Login = () => {
  const history = useHistory();
  const signup = async (e) => {
    const data = new FormData(e.target);

    try {
      const { error } = await supabase.auth.signUp({
        email: data.get("email"),
        password: data.get("password"),
      });
      if (error) throw error;
      //   alert("SignUp Successful. Redirecting...");
      console.log(history);
      history.goBack();
    } catch (error) {
      alert(error.message);
    }
  };

  const signin = async (e) => {
    const data = new FormData(e.target);
    try {
      const { error } = await supabase.auth.signIn({
        email: data.get("email"),
        password: data.get("password"),
      });
      if (error) throw error;
      //   alert("SignIn Successful. Redirecting...");
      console.log(history);

      history.goBack();
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    supabase.auth.user() && history.push("/dashboard");
  }, [history]);

  return (
    <LargeContainer>
      <MainContainer halign="space-between" style={{ marginTop: "6em" }}>
        <Left
          onSubmit={(e) => {
            e.preventDefault();
            signup(e);
          }}
        >
          <Heading>Register</Heading>
          <label htmlFor="email">Email Address</label>
          <input type="email" name="email" placeholder="Email" />
          <label htmlFor="password">Password</label>
          <input type="password" name="password" placeholder="Password" />
          <Button type="submit">Register</Button>
        </Left>
        <Right
          onSubmit={(e) => {
            e.preventDefault();
            signin(e);
          }}
        >
          <Heading>LogIn</Heading>

          <label htmlFor="email">Email Address</label>
          <input type="email" name="email" placeholder="Email" required />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            required
          />
          <Button type="submit">Login</Button>
        </Right>
      </MainContainer>
    </LargeContainer>
  );
};
const Left = styled.form`
  display: flex;
  flex-direction: column;
  width: 40%;
  padding: 1em;
  box-shadow: 1px 1px 5px #ddd;

  input,
  button {
    padding: 1em;
    margin: 1em 0;
  }
  input {
    border: 1px solid #ddd;
  }
`;
const Right = styled.form`
  display: flex;
  flex-direction: column;
  width: 40%;
  padding: 1em;
  box-shadow: 1px 1px 5px #ddd;

  input,
  button {
    padding: 1em;
    margin: 1em 0;
  }
  input {
    border: 1px solid #ddd;
  }
`;

const Heading = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  margin: 1em 0;
  color: #444;
`;
const Button = styled.button`
  width: 8em;
  border: none;
  align-self: flex-start;
  margin-top: 1em;
  padding: 1em 2em;
  background-color: #83aa4c;
  border-radius: 32px;
  color: white;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
  :hover {
    scale: 1.1;
  }
`;
export default Login;
